import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M15 3.59 11.41 0l-9.1 9.09L1 14l4.91-1.31L15 3.59Zm-9 7.59-.74-.74 7.56-7.62.77.77L6 11.18Zm6.11-9.07L4.56 9.73l-.74-.74 7.59-7.58.7.7ZM3.17 9.75l2.08 2.08-2.84.76.76-2.84ZM15 15H1v1h14v-1Z" />
  </IconWrapper>
)

export default EditIconSmall
